'use client'
import { createContext, useContext } from 'react'
import { useAssistant } from './useAssistant'

type AssistantContextType = ReturnType<typeof useAssistant>

const AssistantContext = createContext<AssistantContextType | null>(null)

export function AssistantProvider({ children }: { children: React.ReactNode }) {
  const assistant = useAssistant()
  return <AssistantContext.Provider value={assistant}>{children}</AssistantContext.Provider>
}

export function useAssistantContext() {
  const ctx = useContext(AssistantContext)
  if (!ctx) throw new Error('AssistantProvider missing')
  return ctx
}
